import ybutton from "./src/ybutton.vue";
// 支持按需引用
ybutton.install = function (Vue) {
  Vue.component(ybutton.name, ybutton);
};
export default ybutton;
